<template>
  <div>
    <slot></slot>
    <div class="add-tag-btn">
      <input class="input-new-tag" v-model="inputValue" @keyup.enter="confirm" type="text">
      <span class="button-new-tag" @click="confirm">+ New Tag</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputVisible: false,
      inputValue: '',
    }
  },
  methods: {
    async confirm() {
      console.log(111111111)
      let { inputValue } = this
      if (inputValue) this.$emit('addTag', inputValue)
      this.inputVisible = false
      this.inputValue = ''
    },
  },
}
</script>
<style scoped>
.add-tag-btn {
  display: inline-flex;
  width: 160px;
  align-items: center;
}
.input-new-tag {
  border: 1px solid;
  border-right: 0;
  width: 50%;
  padding-left: 6px;
  outline: none;
  height: 20px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-sizing: border-box;
}
.button-new-tag {
  color: #fff;
  height: 20px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #66b1ff;
  box-sizing: border-box;
  line-height: 20px;
  width: 50%;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
</style>
